import "./H3.scss"

export const H3 = ({ children = null, className = "" }) => (
  <div
    className={`H3 maax-font-weight-black-condensed ${className}`}
    data-testid="H3"
  >
    {children}
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// H3.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// H3.defaultProps = {
//   children: null,
//   className: "",
// }
